import { useAppConfig } from '../../acl/acl-provider.tsx';

export function useAskPlatoEnabled(): boolean {
    const { enableAiChat } = useAppConfig();

    return enableAiChat;
}
